export default "__VITE_ASSET__d701864d__"